import { max } from 'lodash';
import React, { PropsWithChildren } from 'react';
import { useDispatch } from 'react-redux';
import { StripContent } from '../../plot/components/StripContent';
import {
  EventHandler,
  StripInteractions,
} from '../../plot/components/StripInteractions';
import { StripWindow } from '../../plot/components/StripWindow';
import { useMovingWindow } from '../../plot/hooks/useMovingWindow';
import { useStrip } from '../../plot/hooks/useStrip';
import * as navigationActions from '../actions/navigation.actions';
import { navigateTo } from '../thunks/navigate-to.thunk';
import { CursorPosition } from './CursorPosition';

type Props = PropsWithChildren<{
  durations: number[];
}>;

export const Navigator: React.FC<Props> = ({ durations, children }) => {
  const dispatch = useDispatch();
  const { offset } = useStrip();
  const maxDuration = max(durations);
  const { start, end } = useMovingWindow(maxDuration ?? 0);
  const handler: EventHandler = (eventType, timestamp) => {
    switch (eventType) {
      case 'click':
      case 'mousedown':
      case 'mouseup': {
        if (timestamp < start || timestamp > end + offset) {
          dispatch(navigationActions.go({ timestamp }));
        }
        break;
      }
      case 'mousemove':
        dispatch(navigateTo(timestamp));
        break;
    }
  };

  return (
    <StripContent clipType='plot'>
      <StripWindow>
        <StripInteractions eventHandler={handler}>
          {durations.map((duration) => (
            <CursorPosition key={duration} duration={duration} />
          ))}
          {children}
        </StripInteractions>
      </StripWindow>
    </StripContent>
  );
};
